import script from "./Return.vue?vue&type=script&setup=true&lang=js"
export * from "./Return.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__